import {typeOptions, statusOptions} from '@/constants/consignment-constants';
import {states} from '@/constants/receipt-constants';

export const getConsignmentTypeByKey = (key) => {
    let type = typeOptions.find(type => (type.key === key));
    return !!type ? type.value : null;
};

export const getConsignmentStatusByKey = (key) => {
    let status = statusOptions.find(status => (status.key === key));
    return !!status ? status.value : null;
};

export const consignmentStatusIsPosted = (key) => {
    return (key === 'POSTED');
};

export const consignmentStatusIsIssued = (key) => {
    return (key === 'ISSUED');
};

export const getStatusByKey = (key) => {
  let status = states.find(status => (status.key === key));
  return !!status ? status.value : null;
};
